<template>
    <ui-modal name="launch-create-success">
        <div class="container-launch-create-success">
            <div class="container-launch-create-success-modal">
                <div class="container-modal-content">
                    <div class="container-modal-content-circle-check">
                        <em class="fal fa-check" />
                    </div>

                    <div class="container-modal-content-line">
                        <p class="container-modal-content-line-title">
                            <span class="container-modal-content-line-title-launch">Lançamento </span>
                            criado com sucesso!
                        </p>
                        <p class="container-modal-content-line-subtitle">O que você deseja fazer agora?</p>
                    </div>
                </div>

                <div style="width: 100%">
                    <ui-actions-deals-wrapper-list v-model="actions" />
                </div>

                <ui-button
                    design="primary md mw-150"
                    style="margin-top: 20px"
                    @click="actionHandler"
                >
                    Avançar
                </ui-button>
            </div>
        </div>
    </ui-modal>
</template>

<script>
    import { uiModal } from "@/components/ui/modal"
	import { uiButton } from '@/components/ui/buttons'
	import { uiActionsDealsWrapperList } from '@/components/ui-facilita/wrapper'
	import { defaultActionList, defaultMenuList, defaultForm } from '../data'

	import { mapActions } from 'vuex'

	export default {
		name: 'launch-create-success-modal',

		components: {
			uiModal,
			uiButton,
			uiActionsDealsWrapperList
		},

		data() {
			return {
				actions: [...defaultActionList()]
			}
		},

		methods: {
			...mapActions('launchDay', ['setConfig', 'setSteps']),
			/**
			 * Event handler que trata o evento de quando uma ação foi selecionada e é requerido
			 * executar tal ação
			 */
			actionHandler() {
				const action = this.actions.find(action => action.check === true)
				if (!action) return

				let route = ''
				switch (action.action) {
					case 'control--launch':
						route = 'launch.management.computerServicePoint'
						break

					case 'register--launch':
						this.setConfig({ ...defaultForm() })
						this.setSteps([ ...defaultMenuList() ])
						route = 'launch.management.create.mainData'
						break
				}

				if (route) this.$router.push({ name: route })
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>